import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Mail, Loader2 } from "lucide-react";
import { API } from "@/App";

export default function DigestOptInToggle() {
  const [enabled, setEnabled] = useState(false);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const res = await axios.get(`${API}/digest/preference`, { withCredentials: true });
        setEnabled(!!res.data?.digest_optin);
      } catch {
        setEnabled(false);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const toggle = async () => {
    const next = !enabled;
    setSaving(true);
    setEnabled(next);
    try {
      await axios.put(
        `${API}/digest/preference`,
        { digest_optin: next },
        { withCredentials: true }
      );
      toast.success(next ? "You'll get the weekly digest" : "Digest unsubscribed");
    } catch (e) {
      setEnabled(!next);
      toast.error(e.response?.data?.detail || "Could not save preference");
    } finally {
      setSaving(false);
    }
  };

  if (loading) return null;

  return (
    <div
      className="bg-white rounded-xl border border-gray-100 p-4 flex items-center justify-between gap-4"
      data-testid="digest-optin-card"
    >
      <div className="flex items-start gap-3 min-w-0">
        <div className="w-9 h-9 rounded-full bg-tbc-cream flex items-center justify-center flex-shrink-0">
          <Mail className="w-4 h-4 text-tbc-navy" />
        </div>
        <div className="min-w-0">
          <p className="font-medium text-tbc-navy text-sm">Weekly Digest</p>
          <p className="text-xs text-gray-500 mt-0.5">
            Every Monday: new businesses and the week&apos;s featured spotlights, delivered to your inbox.
          </p>
        </div>
      </div>

      <button
        onClick={toggle}
        disabled={saving}
        className={`relative inline-flex h-6 w-11 flex-shrink-0 rounded-full transition-colors ${
          enabled ? "bg-tbc-navy" : "bg-gray-300"
        }`}
        data-testid="digest-optin-toggle"
        aria-pressed={enabled}
      >
        <span
          className={`inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition ${
            enabled ? "translate-x-5" : "translate-x-0.5"
          } translate-y-0.5`}
        />
        {saving && (
          <Loader2 className="absolute inset-0 m-auto w-3 h-3 animate-spin text-white" />
        )}
      </button>
    </div>
  );
}
